export default "__VITE_ASSET__568a86f7__"